export default __webpack_public_path__ + "static/media/Talend.44756df8.png";